// src/utils/playerUtils.ts

/**
 * Mapas de faixas de nota por nível
 */
const niveis = {
  iniciante: { min: 0, max: 20 },
  basico: { min: 21, max: 40 },
  intermediario: { min: 41, max: 60 },
  avancado: { min: 61, max: 80 },
  profissional: { min: 81, max: 100 },
} as const;

export type NivelKey = keyof typeof niveis;

/**
 * Converte uma nota (0..100) para a chave do nível correspondente
 */
export function notaParaNivelKey(nota: number): NivelKey {
  if (nota >= 0 && nota <= 20) return 'iniciante';
  if (nota >= 21 && nota <= 40) return 'basico';
  if (nota >= 41 && nota <= 60) return 'intermediario';
  if (nota >= 61 && nota <= 80) return 'avancado';
  if (nota >= 81 && nota <= 100) return 'profissional';
  return 'iniciante'; // fallback
}

/**
 * Converte um nível selecionado (1 a 5) para uma nota (0 a 100)
 */
export function nivelParaNota(nivel: number): number {
  switch (nivel) {
    case 1: return 10;  // iniciante (0-20)
    case 2: return 30;  // básico (21-40)
    case 3: return 50;  // intermediário (41-60)
    case 4: return 70;  // avançado (61-80)
    case 5: return 90;  // profissional (81-100)
    default: return 10;
  }
}

/**
 * Gera um valor aleatório dentro da faixa do nível
 */
export function gerarNotaPorNivel(nivelKey: NivelKey): number {
  const faixa = niveis[nivelKey];
  return Math.floor(Math.random() * (faixa.max - faixa.min + 1)) + faixa.min;
}

/**
 * Gera características iniciais de um jogador com base na nota (0..100)
 * Cada característica recebe um valor aleatório dentro da faixa do nível correspondente
 */
export function gerarCaracteristicasPorNivel(nota: number) {
  const nivelKey = notaParaNivelKey(nota);

  return {
    velocidade: gerarNotaPorNivel(nivelKey),
    finalizacao: gerarNotaPorNivel(nivelKey),
    passe: gerarNotaPorNivel(nivelKey),
    drible: gerarNotaPorNivel(nivelKey),
    defesa: gerarNotaPorNivel(nivelKey),
    fisico: gerarNotaPorNivel(nivelKey),
  };
}
 